import { GraphQlClient } from '@intelipost-js/secure-providers';

export default {
  getAnalyticsDetail({ commit }, params) {
    commit('toggleLoading', true);

    return GraphQlClient.query(`
    query (
      $warehouses: [Int],
      $date_range: String,
      $logistic_providers_id: String
    ) {
      reconAnalyticDetail(
        warehouses: $warehouses,
        date_range: $date_range,
        logistic_providers_id: $logistic_providers_id
      ) {
        invoice
        invoice_serie
        order_number
        logistic_provider_name
        warehouse
        dispatch_date
        tms_freight_value
        logistic_provider_freight_value
      }
    }
    `, params)
    .then(({ data }) => {
      const { reconAnalyticDetail } = data || {};

      commit('setAnalyticDetail', reconAnalyticDetail || []);
      commit('toggleLoading', false);
    })
    .catch(() => commit('toggleLoading', false));
  },
  exportsDetail({ commit }, params) {
    commit('toggleLoadingExports', true);

    return GraphQlClient.query(`
    query (
      $warehouses: [Int],
      $date_range: String,
      $logistic_providers_id: String
    ) {
      exportAnalyticDetail(
        warehouses: $warehouses,
        date_range: $date_range,
        logistic_providers_id: $logistic_providers_id
      ) {
        ok
      }
    }
    `, params)
    .then(() => {
      commit('toggleLoadingExports', false);
    })
    .catch(() => commit('toggleLoadingExports', false));
  },
};




// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/analytics-detail/store/actions.js